import {createAction} from '@reduxjs/toolkit';

export const clearGlobalThreadsList = createAction('threads/actions/clearGlobalThreadsList');
